import styles from './index.module.scss'
import { useSearchParams } from "react-router-dom";
import {list} from '../../artical';
import { useEffect, useState } from 'react';

const Card1 = () => {
  const [searchParams] = useSearchParams();
  const [dataList] = useState(list)
  const [itemInfo,setItemInfo] = useState({})

  useEffect(()=>{

    const key = searchParams.get("key");
    dataList.map(items => {
      if(items.key===key){
        setItemInfo(items)
      }
    })
  },[searchParams])


   return (
     <div className='w-1260'>
       <div className={`flex ${styles.card} flex-just flex-wrap`}>
         <div className={`flex ${styles.boxLeft}`}>
           {itemInfo.title}
         </div>
         <div className={`flex ${styles.boxRight}`}>
           {itemInfo.subTitle}
         </div>
       </div>
       <div className={`${styles.line}`}/>
     </div>

   )
}

export default Card1